import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * Contract for components that need to warn the user about
 * unsaved changes before leaving the page.
 */
export interface CanComponentDeactivate {
  /**
   * Determines whether the component can be safely navigated away from.
   * Implementations should prompt the user for confirmation when unsaved
   * changes are present and resolve with the user's decision.
   * @returns `true`/an observable or promise of `true` to allow navigation;
   * `false` to cancel navigation and remain on the page.
   */
  canDeactivate(): boolean | Observable<boolean> | Promise<boolean>;
}

/**
 * Route guard that defers the leave-page decision to the component
 * being navigated away from, so it can warn about unsaved changes.
 * @param component - Component instance currently activated on the route.
 * @returns The result of the component's own `canDeactivate` check.
 */
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => component.canDeactivate();
